module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-address"
  }, [_c('el-cascader', _vm._b({
    attrs: {
      "options": _vm.state.addressData,
      "props": _vm.props
    },
    on: {
      "change": _vm.change,
      "blur": _vm.blur,
      "focus": _vm.focus
    },
    model: {
      value: (_vm.selectedValue),
      callback: function($$v) {
        _vm.selectedValue = $$v
      },
      expression: "selectedValue"
    }
  }, 'el-cascader', _vm.$attrs, false))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-56adb760"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/cascader/rtAddress.vue
// module id = 1431
// module chunks = 116